// @@@@manuel This is super hacky, but we need to unblock Hugo so he can finish Younited's setup...

export const shouldCalculateMetrics = (accountId: string) =>
  accountId !== '4685a577-81a9-487c-9008-3035fe444a09'; //Younited Credit
